<template>
    <b-col lg="4" cols="12">
        <div class="form-item form-item-amount">
            <p>Enter payout amount:</p>
            <div class="transfer-value" :class="{ 'field-error': (errors.has('payout_amount') && showErrors) || (amountError && showErrors) || (maxAmountError && showErrors) }">
                <input type="text"
                       name="payout_amount"
                       id="payout_amount"
                       v-validate
                       data-vv-rules="required|currency|money|greaterThanZero"
                       data-vv-as="amount"
                       v-model="fieldValue">
                <div class="currency">FND</div>
            </div>
            <p class="field-error--description"
               v-show="errors.has('payout_amount') && showErrors">{{ errors.first('payout_amount') }}</p>

        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        dependencies: ['money'],
        props: ['amountError', 'maxAmountError', 'minimum', 'percent', 'showErrors', 'setValue'],
        data () {
            return {
                fieldValue: 0
            }
        },
        watch: {
            fieldValue () {
                this.setValue('amount', this.fieldValue);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/payout/common/Amount.vue